import { render, staticRenderFns } from "./DistributorCard.vue?vue&type=template&id=6947f48f&scoped=true"
import script from "./DistributorCard.vue?vue&type=script&lang=js"
export * from "./DistributorCard.vue?vue&type=script&lang=js"
import style0 from "./DistributorCard.vue?vue&type=style&index=0&id=6947f48f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6947f48f",
  null
  
)

export default component.exports